export default Object.freeze({
  INSIGHT_VM: 'InsightVM',
  NEXPOSE_ENTERPRISE: 'Enterprise',
});
